module.exports = __webpack_public_path__ + "static/media/facility-south-02sm.98e02aac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/facility-south-02sm.jpg
// module id = 31
// module chunks = 0